import { CsvImporter } from '../components/CsvImporter';

export const ClientCsvImport = () => <CsvImporter isInvoiceMode={false} />;
